import React from 'react'
import { SvgIcon } from '@mui/material'

export const BadgeCheckIcon = props => (
  <SvgIcon viewBox="0 0 10 8" sx={{ width: '10px', height: '8px' }} {...props}>
    <path
      d="M3.77799 5.03843L7.83242 0.943661C8.0095 0.7663 8.24903 0.666748 8.49871 0.666748C8.74839 0.666748 8.98792 0.7663 9.165 0.943661C9.25358 1.03219 9.32389 1.13751 9.37187 1.25355C9.41985 1.3696 9.44455 1.49406 9.44455 1.61977C9.44455 1.74548 9.41985 1.86995 9.37187 1.98599C9.32389 2.10204 9.25358 2.20736 9.165 2.29589L4.43955 7.05724C4.26352 7.23317 4.02592 7.33235 3.77799 7.3334C3.65361 7.33412 3.53031 7.3101 3.41516 7.26271C3.30001 7.21532 3.19528 7.1455 3.10697 7.05724L0.886014 4.80988C0.78708 4.72451 0.706728 4.61946 0.650001 4.50132C0.593274 4.38317 0.561396 4.25449 0.556368 4.12334C0.551341 3.9922 0.573273 3.86142 0.620787 3.73922C0.668301 3.61702 0.740371 3.50604 0.832474 3.41323C0.924578 3.32043 1.03473 3.24781 1.156 3.19994C1.27728 3.15206 1.40707 3.12996 1.53723 3.13503C1.66739 3.14009 1.7951 3.17221 1.91235 3.22937C2.0296 3.28653 2.13387 3.36749 2.21859 3.46718L3.77799 5.03843Z"
      fill="white"
      width="10"
      height="8"
      viewBox="0 0 10 8"
    />
  </SvgIcon>
)
